import api from '../api/API';

export interface Account {
  type: number,
  name: string
  locationId: string|null,
}

export interface User {
  firstName: string,
  lastName: string,
  email: string,
  password: string,
}

export default function register(account: Account, user: User): Promise<void> {
  return api
    .post('register', { account, user })
    .then(() => undefined);
}
